import { CarModel, getEcommModels, getSeoKey } from "api"
import SeoMetaData, { SeoMetadataWithImage } from "common/SeoMetaData"
import * as authRepository from "components/shopFeatures/auth/authRepository"
import { initAuth } from "components/shopFeatures/auth/authSlice"
import { fetchShowRooms } from "components/shopFeatures/showRooms/showRoomsSlice"
import Wizard from "components/shopFeatures/wizard/Wizard"
import { fetchModel } from "components/shopFeatures/wizard/wizardSlice"
import ShopLayout from "layout/oldLayout/ShopLayout"
import { GetStaticPaths } from "next"
import React, { useEffect } from "react"
import { HashRouter, StaticRouter } from "react-router-dom"
import { AppDispatch, useAppDispatch, wrapper } from "store"
type ModelStaticProps = { model: string }

export const getStaticPaths: GetStaticPaths<ModelStaticProps> = async () => {
  const { data } = await getEcommModels()

  const paths = data.body.map((model) => ({
    params: { model: model.details.id.toString() },
  }))

  return { paths, fallback: "blocking" }
}

export const getStaticProps = wrapper.getStaticProps(
  (store) =>
    async ({ params }) => {
      if (!params) throw new Error("params is undefined")

      const { model } = params as ModelStaticProps

      // TODO: Wait for https://github.com/kirill-konshin/next-redux-wrapper/pull/247 to be merged and remove this

      // we use dispatch like this, not like useAppDispatch because
      // we cant use hooks inside get staticProps
      const dispatch = store.dispatch as AppDispatch

      const { payload } = await dispatch(fetchModel(model))

      if (!payload) {
        return {
          redirect: { destination: "/models/shop", permanent: false },
          revalidate: 60,
        }
      }

      const seoData = await getSeoKey("ShopModelTemplate")
      const carModel = payload as CarModel

      const seo = {
        title:
          seoData.data.body?.title.replace("{modelName}", carModel.name) ||
          carModel.name,
        description:
          seoData.data.body?.description.replace(
            "{modelName}",
            carModel.name
          ) || "",
        keywords: seoData.data.body?.keywords || "",
        image: carModel?.image || null,
        noIndex: true,
      }
      return {
        props: { model: payload as CarModel, seo: seo },
        revalidate: 60,
      }
    }
)

type ModelProps = { seo: SeoMetadataWithImage }

const Router: React.FC<any> =
  typeof window !== "undefined"
    ? (props) => <HashRouter {...props} />
    : (props) => <StaticRouter {...props} />

const Model = ({ seo }: ModelProps) => {
  //  todo gil there is a problem here:
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(initAuth(authRepository.getToken()))
    dispatch(fetchShowRooms())
  }, [dispatch])

  return (
    <>
      <SeoMetaData data={seo} />

      <ShopLayout>
        <Router>
          <Wizard />
        </Router>
      </ShopLayout>
    </>
  )
}

export default Model
